import { red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";
import { theme as globalTheme } from "@creditsafe/ui-components";
import "flag-icons/css/flag-icons.min.css";

export const theme = {
  ...globalTheme,
  // Color code for Risk status and Kyc status circle
  highRisk: "#ff1e26",
  veryLowRisk: "#409A6A",
  veryHighRisk: "#b70f0a",
  new: "#cbcbcb",
  approved: "#409A6A",
  declined: "#ff1e26",
  pending: "#f7941d",
  cancelled: "#cbcbcb",
  referred: "#f7941d",
  closed: "#cbcbcb",
  notApplicable: "#cbcbcb",
  lowRisk: "#6DC797",
  mediumRisk: "#f7941d",
  approvedReviewDue: "#6DC797",
  notApplicableRisk: "#cbcbcb",
};

export const muiTheme = createTheme({
  typography: {
    htmlFontSize: 10,
    fontFamily: theme.typography.fontFamilyPrimary,
    fontSize: 12,
  },
  palette: {
    primary: {
      main: "#ee2e24",
    },
    secondary: {
      main: "#8d8d8d",
    },
    error: {
      main: red.A400,
    },
  },

  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            "&:hover fieldset": {
              borderColor: "#80bdff",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#80bdff",
            },
          },
        },
      },
    },
  },
});
